// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { EnvironmentInterface } from './environment-interface';

export const environment: EnvironmentInterface = {
  production: false,
  stageTitle: 'MyU local',
  be_url: 'api/amr/myupdates-be-next/v1/',
  be_personal_url: 'api/amr/myupdates-personal-next/v1/',
  mydatev_context_api_url: 'api/amr/mydatev-context/v1/',
  entryPoint: 'http://localhost:4200/myupdates/',
  adobe_analytics_script_url:
    'https://apps.dev.datev.de/analytics/fd71f4fdb4e9/52de250c84f7/launch.min.js',
  cookie_dialog_url:
    'https://apps.dev.datev.de/analytics/onetrust/datev.de/scripttemplates/otSDKStub.js',
  mainReleaseUrlPart: '/delivery/main-products/del.delivery.3027',
  mainReleaseLfuUrlPart: '/delivery/main-products/del.delivery.3033',
  feature: 'REDESIGN_HOMEPAGE',
  inactivityTimeout: 10 * 60 * 1000,
  disableSessionManagement: true,
  passiveTMA: 'https://www.datev-umfrage.de/uc/tma2/?a=DATEV%20MyUpdates&b=hat%20DATEV%20MyUpdates&c=95CCF09F89274DA898D10076B0CB63F3&d=0&e=0&f=K-M&g=&i=&j=&k=',
  activeTMA: {
    reverseProxyType: 'local',
    surveyUrl:
      'https://www.datev-umfrage.de/uc/tma5/?a=dem%20Download%20Bereich%20in%20DATEV%20MyUpdates&b=hat%20der%20Download%20Bereich%20in%20DATEV%20MyUpdates&c=4553FC5A21DD4BEC9BE846A3CA16EE54&d=0&e=1&f=G&g=&h=&i=&j=&k=',
    probability: 1,
  },
  downloadDetailsDocViewerBaseUrl: 'api/amr/ple-retrieval/v1/pdf-result/',
  knowledgeHelpCenterBaseUrl: 'api/amr/knowledge-help-center/v1/',
  knowledgeCommonBaseUrl: 'api/amr/knowledge-common/v1/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

declare global {
  interface Window {
    environment: object;
  }
}                  
if(typeof window.environment != 'string') {                
    Object.assign(environment,window.environment);
}                   
